import { useRouter } from 'next/router'
import { useMemo } from 'react'

export const useUserId = () => {
  const router = useRouter()
  return useMemo(() => {
    return router.query.uid?.toString() || ''
  }, [router.query.uid])
}
